import { BomPartType } from 'bom/enums';
import { IBomPart } from 'bom/types';

import { PartDescriptionTypeComponent } from './PartDescriptionTypeComponent';
import { PartDescriptionTypePart } from './PartDescriptionTypePart';

interface IProps {
  bomPart: IBomPart;
  extra?: string;
}

export const PartDescription = ({ bomPart, extra }: IProps) => {
  const getDescription = () => {
    switch (bomPart.type) {
      case BomPartType.PART:
        return <PartDescriptionTypePart bomPart={bomPart} extra={extra} />;
      case BomPartType.COMPONENT:
        return <PartDescriptionTypeComponent bomPart={bomPart} />;
      default:
        return;
    }
  };

  return getDescription();
};
